export default {
    strip_input: function ($input) {
        var validation_type = $input.attr('data-adapt-validate');
        var value = $input.val();

        switch (validation_type) {
            case "number":
            case "integer":
                value = value.replace(/[^0-9]/g, '');
                break;
            case "decimal":
            case "float":
            case "currency":
            case "uk_currency":
            case "us_currency":
            case "eu_currency":
                value = value.replace(/[^.0-9]/g, '');
                break;
            case "name":
                break;
            case "uk_phone":
            case "uk_phone_mobile":
            case "uk_phone_home":
            case "uk_phone_work":
                value = value.replace(/[^0-9]/g, '');
                break;
            case "email":
                break;
            case "uk_postcode":
                value = value.replace(/[^A-Za-z0-9]/, '');
                break;
            case "bank_sort_code":
            case "bank_account_number":
            case "uk_date":
            case "us_date":
            case "iso_date":
            case "uk_datetime":
            case "us_datetime":
            case "iso_datetime":
            case "uk_time":
            case "us_time":
            case "iso_time":
                value = value.replace(/[^0-9]/g, '');
                break;
        }

        $input.val(value);
    },
    validate_input: function ($input) {
        var validation_type = $input.attr('data-adapt-validate');
        var value = $input.val();
        var valid = false;

        switch (validation_type) {
            case "number":
            case "integer":
                valid = /^[-]?[0-9]+$/.test(value);
                break;
            case "decimal":
            case "float":
            case "currency":
            case "uk_currency":
            case "us_currency":
            case "eu_currency":
                valid = /^[-]?[0-9]*([.][0-9]{1,2}){0,1}$/.test(value);
                break;
            case "name":
                valid = /^[A-Za-z]+([ \'-][A-Za-z]+)*$/.test(value);
                break;
            case "uk_phone":
                valid = /^0[1235789]{1,1}[0-9]{9,9}$/.test(value);
                break;
            case "uk_phone_mobile":
                valid = /^07[0-9]{9,9}$/.test(value);
                break;
            case "uk_phone_home":
                valid = /^0[125]{1,1}[0-9]{9,9}$/.test(value);
                break;
            case "uk_phone_work":
                valid = /^0[12358]{1,1}[0-9]{9,9}$/.test(value);
                break;
            case "email":
                valid = value.length <= 128 && /^\w+([\-.]?\w+)*@([-\w.]+)\.[\w]+$/.test(value);
                break;
            case "uk_postcode":
                if (ireland_postcode) {
                    valid = /^(GIR( )+0AA|[A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]|[A-HK-Y][0-9]([0-9]|[ABEHMNPRV-Y]))|[0-9][A-HJKPS-UW])( )?[0-9][ABD-HJLNP-UW-Z]{2}|[AC-Y]{1}[0-9]{1}[0-9W]{1}[ \-]?[0-9AC-Y]{4})$/i.test(value);
                } else {
                    valid = /^(GIR( )+0AA|[A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]|[A-HK-Y][0-9]([0-9]|[ABEHMNPRV-Y]))|[0-9][A-HJKPS-UW])( )?[0-9][ABD-HJLNP-UW-Z]{2})$/i.test(value);
                }

                break;
            case "bank_sort_code":
                valid = /^[0-9]{6,6}$/.test(value);
                break;
            case "bank_account_number":
                valid = /^[0-9]{8,8}$/.test(value);
                break;
            case "uk_date":
                var day = 0;
                var month = 0;
                var year = 0;
                if (/^[0-9]{8,8}$/.test(value)) {
                    day = parseInt(value.substring(0, 2), 10);
                    month = parseInt(value.substring(2, 4), 10);
                    year = parseInt(value.substring(4, 8), 10);
                } else {
                    if (/^[0-9]{6,6}$/.test(value)) {
                        day = parseInt(value.substring(0, 2), 10);
                        month = parseInt(value.substring(2, 4), 10);
                        year = parseInt(value.substring(4, 6), 10);
                        if (year < 50) {
                            year = year + 2000;
                        } else {
                            year = year + 1900;
                        }
                    } else {
                        valid = false;
                    }
                }

                var days = Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
                if (new Date(year, 1, 29).getDate() == 29) {
                    days[1] = 29;
                }

                if ((month >= 1) && (month <= 12)) {
                    if ((day >= 1) && (day <= days[month - 1])) {
                        valid = true;
                    }
                }
                //valid = false;
                break;
            case "us_date":
                var day = 0;
                var month = 0;
                var year = 0;

                if (/^[0-9]{8,8}$/.test(value)) {
                    day = parseInt(value.substring(2, 4), 10);
                    month = parseInt(value.substring(0, 2), 10);
                    year = parseInt(value.substring(4, 8), 10);
                } else {
                    if (/^[0-9]{6,6}$/.test(value)) {
                        day = parseInt(value.substring(2, 4), 10);
                        month = parseInt(value.substring(0, 2), 10);
                        year = parseInt(value.substring(4, 6), 10);
                        if (year < 50) {
                            year = year + 2000;
                        } else {
                            year = year + 1900;
                        }
                    } else {
                        valid = false;
                    }
                }

                var days = Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
                if (new Date(year, 1, 29).getDate() == 29) {
                    days[1] = 29;
                }

                if ((month >= 1) && (month <= 12)) {
                    if ((day >= 1) && (day <= days[month - 1])) {
                        valid = true;
                    }
                }
                //valid = false;
                break;
            case "iso_date":
                var day = 0;
                var month = 0;
                var year = 0;

                if (/^[0-9]{8,8}$/.test(value)) {
                    day = parseInt(value.substring(6, 8), 10);
                    month = parseInt(value.substring(4, 6), 10);
                    year = parseInt(value.substring(0, 4), 10);
                } else {
                    if (/^[0-9]{6,6}$/.test(value)) {
                        day = parseInt(value.substring(4, 6), 10);
                        month = parseInt(value.substring(2, 4), 10);
                        year = parseInt(value.substring(0, 2), 10);
                        if (year < 50) {
                            year = year + 2000;
                        } else {
                            year = year + 1900;
                        }
                    } else {
                        valid = false;
                    }
                }

                var days = Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
                if (new Date(year, 1, 29).getDate() == 29) {
                    days[1] = 29;
                }

                if ((month >= 1) && (month <= 12)) {
                    if ((day >= 1) && (day <= days[month - 1])) {
                        valid = true;
                    }
                }
                //valid = false;
                break;
            case "uk_datetime":
                if (/^[0-9]{14,14}$/.test(value)) {
                    valid = adapt.sanitize.validate('uk_date', value.substring(0, 8)) && adapt.sanitize.validate('uk_time', value.substring(8, 14));
                }
                valid = false;
                break;
            case "us_datetime":
                if (/^[0-9]{14,14}$/.test(value)) {
                    valid = adapt.sanitize.validate('us_date', value.substring(0, 8)) && adapt.sanitize.validate('us_time', value.substring(8, 14));
                }
                //valid = false;
                break;
            case "iso_datetime":
                if (/^[0-9]{14,14}$/.test(value)) {
                    valid = adapt.sanitize.validate('us_date', value.substring(0, 8)) && adapt.sanitize.validate('us_time', value.substring(8, 14));
                }
                //valid = false;
                break;
            case "uk_time":
            case "us_time":
            case "iso_time":
                if (/^[0-9]{4,4}$/.test(value)) {
                    var hour = parseInt(value.substring(0, 2), 10);
                    var minute = parseInt(value.substring(2, 4), 10);
                    //var second = parseInt(value.substring(4,6), 10);
                    //if (hour <= 23 && minute <= 59 && second <= 59) valid = true;
                    if (hour <= 23 && minute <= 59) valid = true;
                }
                //valid = false;
                break;
            default:
                valid = true;
        }

        if (!valid) {
            /* Apply error class */
            $input.parents('.form-group').addClass('has-error');
        }

        return valid;
    },
    format_input: function ($input) {
        var validation_type = $input.attr('data-adapt-validate');
        var value = $input.val();

        switch (validation_type) {
            case "decimal":
            case "float":
            case "currency":
                var num = value.toString().replace(/\$|\,/g, '');
                if (isNaN(num)) num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num * 100 + 0.50000000001);
                var cents = num % 100;
                num = Math.floor(num / 100).toString();
                if (cents < 10) cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
                    num = num.substring(0, num.length - (4 * i + 3)) + ',' +
                        num.substring(num.length - (4 * i + 3));
                value = (((sign) ? '' : '-') + num + '.' + cents);
                break;
            case "uk_currency":
                value = "£" + adapt.sanitize.format('currency', value);
                break;
            case "us_currency":
                value = "$" + adapt.sanitize.format('currency', value);
                break;
            case "eu_currency":
                value = "€" + adapt.sanitize.format('currency', value);
                break;
            case "name":
                var breaks = Array(' ', '\'', '-');
                var break_found = true;
                var is_break = false;
                var i, j = 0;
                var output = "";

                for (i = 0; i < value.length; i++) {
                    for (j = 0; j < breaks.length; j++) {
                        if (breaks[j] == value.substr(i, 1)) {
                            break_found = true;
                            is_break = true;
                            output = output + value.substr(i, 1);
                        }
                    }

                    if (!is_break) {
                        if (break_found) {
                            break_found = false;
                            output = output + value.substr(i, 1).toUpperCase();
                        } else {
                            output = output + value.substr(i, 1).toLowerCase();
                        }
                    }

                    is_break = false;
                }
                value = output;
                break;
            case "uk_phone":
            case "uk_phone_mobile":
            case "uk_phone_home":
            case "uk_phone_work":
                switch (value.substring(1, 2)) {
                    case "2":
                        value = value.substring(0, 3) + " " + value.substring(3, 7) + " " + value.substring(7, 11);
                        break;
                    case "8":
                        value = value.substring(0, 4) + " " + value.substring(4, 7) + " " + value.substring(7, 11);
                        break;
                    default:
                        value = value.substring(0, 5) + " " + value.substring(5, 11);
                        break;
                }
                break;
            case "email":
                var emailAfterAt = value.substring(value.indexOf('@') + 1, value.length);
                value = value.substring(0, value.indexOf('@')) + "@" + emailAfterAt.toLowerCase();
                break;
            case "uk_postcode":
                value = value.toUpperCase();
                var start = $.trim(value.substr(0, value.length - 3));
                var end = $.trim(value.substr(value.length - 3));

                value = start + ' ' + end;
                break;
            case "bank_sort_code":
                value = value.substring(0, 2) + "-" + value.substring(2, 4) + "-" + value.substring(4, 6);
                break;
            case "bank_account_number":
                break;
            case "uk_date":
                if (value.length == 6) {
                    year = parseInt(value.substring(4, 6), 10);
                    if (year < 50) {
                        year = year + 2000;
                    } else {
                        year = year + 1900;
                    }
                    value = value.substring(0, 4) + year;
                }
                value = value.substring(0, 2) + "/" + value.substring(2, 4) + "/" + value.substring(4, 8);
                break;
            case "us_date":
                if (value.length == 6) {
                    let year = parseInt(value.substring(4, 6), 10);
                    if (year < 50) {
                        year = year + 2000;
                    } else {
                        year = year + 1900;
                    }
                    value = value.substring(0, 4) + year;
                }
                value = value.substring(2, 4) + "/" + value.substring(0, 2) + "/" + value.substring(4, 8);
                break;
            case "iso_date":
                if (value.length == 6) {
                    let year = parseInt(value.substring(4, 6), 10);
                    if (year < 50) {
                        year = year + 2000;
                    } else {
                        year = year + 1900;
                    }
                    value = value.substring(0, 4) + year;
                }
                value = value.substring(0, 4) + "-" + value.substring(4, 6) + "-" + value.substring(6, 8);
                break;
            case "uk_datetime":
                value = adapt.sanitize.format('uk_date', value.substring(0, 8)) + " " + adapt.sanitize.format('uk_time', value.substring(8, 14));
                break;
            case "us_datetime":
                value = adapt.sanitize.format('us_date', value.substring(0, 8)) + " " + adapt.sanitize.format('us_time', value.substring(8, 14));
                break;
            case "iso_datetime":
                value = adapt.sanitize.format('iso_date', value.substring(0, 8)) + " " + adapt.sanitize.format('iso_time', value.substring(8, 14));
                break;
            case "uk_time":
            case "us_time":
            case "iso_time":
                value = value.substring(0, 2) + ":" + value.substring(2, 4);// + ":" + value.substring(4, 8);
                break;
        }

        $input.val(value);
    }
};
